import { InputHTMLAttributes, ReactElement, useRef } from 'react';

import { FiSearch } from 'react-icons/fi';

import Button from '../Button';

import * as S from './styles';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  name: string;
  // eslint-disable-next-line react/require-default-props
  hideBtn?: boolean;
  onSearch: (query: string) => void;
}

function InputAdmin({
  name,
  onSearch,
  hideBtn,
  ...rest
}: InputProps): ReactElement {
  const inputRef = useRef<HTMLInputElement>(null);

  return (
    <S.Container>
      <FiSearch size={22} style={{ marginInline: '1rem' }} />
      <S.Input
        type="text"
        name={name}
        ref={inputRef}
        {...rest}
        onKeyUp={(event) => {
          if (event.key === 'Enter') {
            onSearch(inputRef.current?.value ?? '');
          }
        }}
      />

      {!hideBtn && (
        <Button
          textContent="Buscar"
          variant="black"
          size="small"
          onClick={() => onSearch(inputRef.current?.value ?? '')}
          style={{ height: 32, width: 150 }}
        />
      )}
    </S.Container>
  );
}

export default InputAdmin;
